import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import Manifesto from "@/pages/Manifesto";
import { AnalyticsRoute } from "@/components/site/AnalyticsRoute";
import Home from "@/pages/Home";
import Careers from "@/pages/Careers";
import Role from "@/pages/Role";
import Partners from "@/pages/Partners";
import PrathamEnquiry from "@/pages/PrathamEnquiry";
import Logbook from "@/pages/Logbook";
import Article from "@/pages/Article";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsRoute />
        <SmoothScroll />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/manifesto" element={<Manifesto />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:slug" element={<Role />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/pratham/enquire" element={<PrathamEnquiry />} />
            <Route path="/logbook" element={<Logbook />} />
            <Route path="/logbook/:slug" element={<Article />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <div className="grain" aria-hidden="true" />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
